import React from 'react';
import fp from 'lodash/fp';
import { SxProps, Theme } from '@mui/system';

import { ArrowsUpdown24 } from 'Modules/ui3/icons/ArrowsUpdown24';

import { Button2 } from '../../Button2';
import { Typography } from '../../Typography';


export interface DisplayMonth {
    onClick: () => void;
    displayMonth: Date;
}


export const CaptionSelector: React.FC<DisplayMonth & { sx?: SxProps<Theme> }> = ({
    onClick, displayMonth, sx,
}) => (
    <Button2
        onClick={onClick}
        variant='secondary'
        sx={{
            position: 'absolute',
            left: 0,
            right: 0,
            margin: 'auto',
            width: 'fit-content',
            px: 2,
            py: 1.5,
            '&:focus': {
                backgroundColor: 'transparent',
            },
            '&:hover': {
                backgroundColor: 'grayscale.shade10',
            },
            ...sx,
        }}
    >
        <Typography
            variant='regularCaption1'
            color='grayscale.shade95'
        >
            {`${fp.upperFirst(
                displayMonth.toLocaleDateString('ru', {
                    month: 'long',
                }),
            )} ${displayMonth.getFullYear()}`}
        </Typography>

        <ArrowsUpdown24
            sx={({ spacing }) => ({
                width: spacing(4),
                height: spacing(4),
                color: 'grayscale.shade95',
                ml: 1,
            })}
        />
    </Button2>
);
